"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_WIZARD_ACTIVITY_PULSE_ACTIVE_MS = exports.WIZARD_ACTIVITY_PULSE_INTERVAL_MS = void 0;
exports.WIZARD_ACTIVITY_PULSE_INTERVAL_MS = 30_000;
exports.MAX_WIZARD_ACTIVITY_PULSE_ACTIVE_MS = 35_000;
//# sourceMappingURL=wizard-activity-pulse.js.map